export default __webpack_public_path__ + "static/media/landing_01.a32ef592.png";